import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import SelectDropDown from "../component/SelectDropDown";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import RegistrationService from "../services/registration";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AlertMsg from "../component/AlertMsg";

const MemberApproval = () => {
  const [show, setShow] = useState(false);
  const [showmodel, setShowModel] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [allUnapproved, setAllUnapproved] = useState([]);

  const [open, setOpen] = useState(false);
  // const [selectedMember, setSelectedMember] = useState({ id: "", title: "" });
  const [usertoken, setUsertoken] = useState("");

  const [memberchange, setMemberChange] = useState({ id: "", title: "" });
  const [kyctypeee, setKyctypee] = useState({ id: "", title: "" });
  const [selectbrand, setSelectBrand] = useState({ id: "", title: "" });
  const [isOTPBlock, setIsOTPBlock] = useState(false);
  const [userinfo, setUserinfo] = useState(false);
  // const [openTsoModal, setOpenTsoModal] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });

  const [membertypelist, setMembertypeList] = useState([]);
  // const [dropkyctype, serDropKyctype] = useState([]);
  // <<<<>>>>
  const [membertype, setMembertype] = useState({ id: "", title: "" });
  const [tsotyle, setTsotype] = useState({ id: "", title: "" });
  const [userasign, setUserasign] = useState({ id: "", title: "" });
  const [kycUplodBlock, setKycUploadBlock] = useState(false);
  const [personaiInfo, setPersonalInfo] = useState({
    full_name: "",
    email_address: null,
    mobile_no: "",
    kyc_details: "",
  });

  const [selectedUser, setSelectedUser] = useState({
    id: "",
    title: "",
    phoneNum: "",
    address: "",
    pinCode: "",
  });
  const [selectedUserasign, setSelectedUserAsign] = useState({
    id: "",
    title: "",
    phoneNum: "",
    address: "",
    pinCode: "",
  });

  const [selectedtso, setSelectedTso] = useState({
    id: "",
    title: "",
    phoneNum: "",
    address: "",
    pinCode: "",
  });

  const [approvalStatus, setApprovalStatus] = useState({
    isSuccess: true,
    heading: "",
    describe: "",
  });

  const [allTsos, setAllTsos] = useState([]);
  const [kycDetailsValidationError, setKycDetailsValidationError] =
    useState("");
  const [mobilenoVerification, setMobileNoverification] = useState("");

  const [persoinfo, setPersoInfo] = useState("");
// <<>>
  const memberTypeChange = (selectedValue) => {
    setMembertype(selectedValue);
  };

  const tsoasign = (selectedValue) => {
    setTsotype(selectedValue);
  };

  const selectUserAsign = (selectedValue) => {
    setUserasign(selectedValue);
  };
  const kycType = (selectedValue) => {
    setKyctypee(selectedValue);
  };
  const setBrandd = (selectedValue) => {
    setSelectBrand(selectedValue);
  };

  // KYC toglar
  const handleVerifyKyc = () => {
    setKycUploadBlock(true);
  };

  // const documentType = [
  //   {
  //     title: "Aadhar",
  //     id: "aadharcard",
  //   },
  //   {
  //     title: "Voter ID",
  //     id: "voterId",
  //   },
  //   {
  //     title: "Driving License",
  //     id: "driving_license",
  //   },
  //   {
  //     title: "PAN",
  //     id: "pan",
  //   },
  // ];

  function reassignHandler() {
    // setOpenTsoModal(true);
    // setShow(true);
    setShowModel(true);
    // alert()
  }
  function reassignHandlerclose() {
    // setOpenTsoModal(true);
    // setShow(true);
    setShowModel(false);
    reassign();
    // alert()
  }

  // useEffect(() => {
  //   // setMembertypeList(ProductDrop);
  //   serDropKyctype(documentType);
  // }, []);

  useEffect(() => {
    RegistrationService.getHierarchies()
      .then((res) => {

        const hier = res.response.hierarchiesDetails.map((item) => {
          return {
            id: item.id,
            title: item.name,
          };
        });
        setMembertypeList(hier);
      })
      .catch((err) => {
      });
  }, []);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    const contactId = userInfo.dcm_contacts_id;

    //   "userInfo>>>>>>>>>>>>>123555555===",
    //   userInfo.dcm_hierarchies_id
    // );

    const usertoken = localStorage.getItem("access_token");
    setUsertoken(usertoken);

    setUserinfo(userInfo);
  }, []);

  useEffect(() => {
    if (memberchange.id !== "") {
      findUsershandler();
    }
  }, []);

  function showToast() {}
  useEffect(() => {
    findUsershandler();
  }, [memberchange.id]);

  useEffect(() => {
    // AsyncStorage.getItem('my-key').then(token => {
    const payload = {
      loginUserHirarchy: parseInt(userinfo.dcm_hierarchies_id),
    };
    RegistrationService.listOfTSOs(payload, usertoken)
      .then((res) => {
        // alert(JSON.stringify(res))
        const tsos = res.response.Data[0].map((tso) => {
          return {
            id: tso.Contact_Id,
            title: tso.Tso_Name,
            branchName: tso.Branch_Name,
            tsoCode: tso.Tso_Code,
          };
        });
        setAllTsos(tsos);
      })
      .catch((err) => {
      });
  });
//   ata dila re render bondho hoba
// }, []);
  // }, [loginUserHirarchy, conId]);

  function approveHandler(key) {
    if (selectedUser.id) {
      // key == "1" means approve and key == "2" means reject
      const payload = {
        userContactId: selectedUser.id,
        is_approved: key,
      };

      //  alert( JSON.stringify(payload))

      RegistrationService.userApprovalByTSO(payload, usertoken)
        .then((res) => {
          //  alert( JSON.stringify(res))
          if (res.success) {
            setShowAlert(true);
            setApprovalStatus({
              isSuccess: true,
              heading:
                key == "1" ? "Approved successful" : "Rejected successfully",
              describe: res.response.message,
            });
            // showToast();
            // resetFields();
          } else {
            // setLoading(false);
          }
        })
        .then((err) => {
          // setLoading(false);
        });
    }
  }

  function findUsershandler() {
    if (userinfo.id) {
      const payload = {
        hierarchy_Id: parseInt(memberchange.id),
      };
      // localStorage.getItem('access_token')
      RegistrationService.listOfUnapprovedUsers(payload, usertoken).then(
        (res) => {
          const unapprovedUsers = res.response.data.map((user) => {
            return {
              id: user.contact_id,
              title: user.fullname,
              phoneNum: user.ph_number,
              address: user.addressline1,
              pinCode: user.post_code,
            };
          });
          setAllUnapproved(unapprovedUsers);
          setOpen(true);
        }
      );
    }
  }

  // Name asper Kyc
  const handleUserNameInfoUpdate = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      full_name: e.target.value,
    });
  };

  const handleUserEmail = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      email_address: e.target.value,
    });
  };

  const handleUserMobileNo = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      mobile_no: e.target.value,
    });
  };

  const kycDetailsinfo = (e) => {
    setPersonalInfo({
      ...personaiInfo,
      kyc_details: e.target.value,
    });
  };

  // --------------------------------------------------------
  const chequeMobileNoVarification = () => {
    const idRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (idRegex.test(personaiInfo.mobile_no)) {
      setMobileNoverification("Mobile no valid");
      setIsOTPBlock(true);
    } else {
      setMobileNoverification("Mobile no invalid");
    }
  };

  function adharNOvarification() {
    const idRegex = /^(\d{12})$/;

    if (idRegex.test(personaiInfo.kyc_details)) {
      setKycDetailsValidationError("Aadhar card number is valid");
    } else {
      setKycDetailsValidationError("Aadhar card number is invalid");
    }
  }

  function handlePreviewBtn() {
    // var jsonString = JSON.stringify(backImage);

    // alert(jsonString )
  }

  // if(selectedUser.id!=="")
  // {
  //   const payload = {
  //     hierarchy_Id: parseInt(selectedMember.id),
  //   };
  //   AsyncStorage.getItem('my-key').then(token => {
  //     RegistrationService.listOfUnapprovedUsers(payload, token).then(res => {

  //       const unapprovedUsers = res.response.data.map(user => {
  //         return {
  //           id: user.contact_id,
  //           title: user.fullname,
  //           phoneNum: user.ph_number,
  //           address: user.addressline1,
  //           pinCode: user.post_code,
  //         };
  //       });
  //       // setAllUnapproved(unapprovedUsers);
  //       // setOpen(true);
  //     });
  //   });
  // }

  // Reasign tso code
  function reassign(selectedUserasign) {
    if (selectedUser.id) {
      // setLoading(true);
      //  alert(selectedUser.id)

      const payload = {
        userContactId: selectedUser.id,
        TSO_contacts_Id: tsotyle.id,
      };

      RegistrationService.assignTsoToUser(payload, usertoken)
        .then((res) => {
          if (res.success) {
            // setLoading(false);
            // alert(JSON.stringify(res));
            // setOpenTsoModal(false);
            setApprovalStatus({
              isSuccess: true,
              heading: "Reassign successful",
              describe: res.response.message,
            });
            // showToast();
          }
        })
        .catch((err) => {
          // setLoading(false);
        });
    }
  }

  // Submit Buttom for server

  function submitForBackend() {}

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Influencer Approval"
        currentPageName="Influencer Approval"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  <h4>Member Approval</h4>
                </div>
                <div className="dashboard-details">
                  <Row>
                    <Col xs={12} lg={6}>
                      <SelectDropDown
                        labelName="Member Type"
                        requiredStar="*"
                        options={membertypelist}
                        setSelectedValue={setMemberChange} 
                        selectedValue={memberchange}
                        onChange={memberTypeChange}
                      />
                    </Col>

                  
                    {memberchange.id !== "" ? (
                      <Col xs={12} lg={6}>
                        <SelectDropDown
                          labelName="Select user"
                          requiredStar="*"
                          options={allUnapproved}
                          setSelectedValue={setSelectedUser}
                          selectedValue={selectedUser}
                          onChange={selectUserAsign}
                        />
                      </Col>
                    ) : null}
                   

                    <Modal
                      show={showmodel}
                      onHide={() => setShowModel(false)}
                      dialogClassName="modal-90w"
                      aria-labelledby="example-custom-modal-styling-title"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                          Re-assign
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p>
                          <Col xs={12} lg={6}>
                            <SelectDropDown
                              labelName="Select TSO"
                              requiredStar="*"
                              options={allTsos}
                              setSelectedValue={setSelectedTso}
                              selectedValue={selectedtso}
                              onChange={tsoasign}
                            />
                          </Col>
                        </p>
                        <Button
                          variant="primary"
                          onClick={reassignHandlerclose}
                        >
                          Save changes
                        </Button>
                         </Modal.Body>
                    </Modal>

                  
                    <Col xs={12} lg={6}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Name"
                        name="kycname"
                        value={selectedUser.title}
                        onChange={handleUserNameInfoUpdate}
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Mobile"
                        name="mobile"
                        value={selectedUser.phoneNum}
                        onChange={handleUserMobileNo}
                      />
                      {mobilenoVerification && (
                        <div className="error-message mb-4 ms-2">
                          {mobilenoVerification}
                        </div>
                      )}

                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Adress"
                        name="kycDetails"
                        // value={personaiInfo.kyc_details}
                        value={selectedUser.address}
                        onChange={kycDetailsinfo}
                      />
                      {kycDetailsValidationError && (
                        <div className="error-message mb-4 ms-2">
                          {kycDetailsValidationError}
                        </div>
                      )}
                    </Col>
                   
                    {/* -------------------------- */}

                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="pincode"
                        name="kycDetails"
                        value={selectedUser.pinCode}
                        // value={personaiInfo.kyc_details}
                        onChange={kycDetailsinfo}
                      />
                      {kycDetailsValidationError && (
                        <div className="error-message mb-4 ms-2">
                          {kycDetailsValidationError}
                        </div>
                      )}
                    </Col>

                    <Col
                      xs={12}
                      lg={6}
                      className="d-flex flex-column align-items-center justify-content-center pt-4"
                    >
                      {showAlert && (
                        <AlertMsg
                          // style={{ paddingTop: "40%" }}
                          alertBoxColor={
                            approvalStatus.isSuccess
                              ? "successAlert"
                              : "FailedAlert"
                          }
                          heading={approvalStatus.heading}
                          text={approvalStatus.describe}
                        />
                      )}
                    </Col>

                    <Col xs={12} lg={6} className="mt-4">
                      {/* <PrimaryGradientButton
                        buttonText="Reject"
                        onClick={approveHandler('2')}
                      /> */}
                      <Button
                        variant="primary"
                        onClick={() => approveHandler("2")}
                        className="w-100 py-3 border-0"
                      >
                        Reject
                      </Button>
                    </Col>

                    <Col xs={12} lg={4} className="mt-4">
                      {/* <PrimaryGradientButton
                        buttonText="Re-assign"
                        onClick={reassignHandler}
                        
                      /> */}
                      <Button
                        variant="btn btn-success"
                        onClick={reassignHandler} // Invoke the function here
                        className="w-100 py-3 border-0"
                      >
                        Re-assign
                      </Button>
                    </Col>

                    <Col xs={12} lg={6} className="mt-4">
                      {/* <PrimaryGradientButton
                        buttonText="Approve"
                        onClick={approveHandler('1')}
                        
                      /> */}

                      <Button
                        variant="danger"
                        onClick={() => approveHandler("1")}
                        className="w-100 py-3 border-0"
                      >
                        Approve
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MemberApproval;
